import styled from "styled-components";
import { mediaMaxWidth } from "../../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  width: 500px;
  right: 0;
  left: 0;
  margin: 0 auto;
  top: 0;
  position: fixed;
  z-index: 2;
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;

  .error-message-fade-appear {
    opacity: 0;
    top: 20px;

    &.error-message-fade-appear-active {
      opacity: 1;
      top: 10px;
      transition: all 300ms ease-in;

      ${mediaMaxWidth.tablet} {
        top: 0;
      }
    }
  }

  .error-message-fade-enter-done {
    top: 10px;

    ${mediaMaxWidth.tablet} {
      top: 0;
    }
  }

  ${mediaMaxWidth.tablet} {
    width: 100vw;
  }
`;

interface IContainerProps {
  email?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f93333;
  background-color: ${(props: IContainerProps) =>
    props.email ? "#f98533" : "#f93333"};
  color: #fff;
  border-radius: 4px;
  padding: 20px 30px;
  position: absolute;

  ${mediaMaxWidth.phone} {
    width: calc(100% - 20px);
    padding: 20px 10px;
    border-radius: 0;
  }
`;

export const Icon = styled.div`
  font-size: 2em;
`;

export const Text = styled.div`
  padding-left: 30px;
`;
